import React from 'react';

import StartOrderButton from './StartOrderButton';
import AssignOrderButton from './AssignOrderButton';
import FulfillOrderButton from './FulfillOrderButton';
import MeterReadingButton from './MeterReadingButton';
import CompleteOrderButton from './CompleteOrderButton';

class ActionButtonFactory {
  static build(fboId, order, onSuccess, onError) {
    switch (order.status) {
      case 'todo':
        return ActionButtonFactory.renderTodo(fboId, order, onSuccess, onError);
      case 'in progress':
        return ActionButtonFactory.renderFulfill(fboId, order, onSuccess, onError);
      case 'fulfilled':
        return ActionButtonFactory.renderComplete(fboId, order, onSuccess, onError);
      case 'closed':
        return (null);
      case 'canceled':
        return ''; // No button at this time
      default:
        return undefined;
    }
  }

  static renderTodo(fboId, order, onSuccess, onError) {
    let defaultButton = (<StartOrderButton
      fboId={fboId}
      orderId={order.id}
      onSuccess={onSuccess}
      onError={onError}
    />);
    if (order.fuelOrders !== null && order.fuelOrders.length > 0) {
      defaultButton = (<AssignOrderButton
        fboId={fboId}
        orderId={order.id}
        onSuccess={onSuccess}
        onError={onError}
      />);
    }

    return defaultButton;
  }

  static renderFulfill(fboId, order, onSuccess, onError) {
    let defaultButton = (<FulfillOrderButton
      fboId={fboId}
      orderId={order.id}
      onSuccess={onSuccess}
      onError={onError}
    />);

    if (order.fuelOrders !== null && order.fuelOrders.length > 0) {
      defaultButton = (<MeterReadingButton
        fboId={fboId}
        orderId={order.id}
        onSuccess={onSuccess}
        onError={onError}
      />);
    }

    return defaultButton;
  }

  static renderComplete(fboId, order, onSuccess, onError) {
    return (<CompleteOrderButton
      fboId={fboId}
      orderId={order.id}
      onSuccess={onSuccess}
      onError={onError}
    />);
  }

  static fakeButton(name) {
    return (
      <div className="action left">
        <button className="btn btn-small btn-primary-outline"> {`<${name}>`} </button>
      </div>
    );
  }
}

export default ActionButtonFactory;



// WEBPACK FOOTER //
// ./src/Containers/Orders/ActionButtons/ActionButtonFactory.js